import { Button, Typography, useTheme } from '@mui/material';
import { useSession } from '@side/next-auth/react';
import type { PartnerDetails } from '../../hooks/useGetPartnerInformation';

interface Props {
  leadAgents: PartnerDetails['leadAgents'] | undefined;
  onClick: () => unknown;
}

export const CorrectInformationText = ({ leadAgents = [], onClick }: Props) => {
  const theme = useTheme();
  const { data: session } = useSession();
  const currentUserId = session?.user.id;
  const currentUserLegacyId = session?.user.legacyExternalId;

  if (
    !currentUserId ||
    !leadAgents.find(
      ({ id, legacyExternalId }) =>
        id === currentUserId || legacyExternalId === currentUserLegacyId,
    )
  ) {
    return null;
  }

  return (
    <Typography
      variant="caption"
      sx={{ fontStyle: 'italic', color: 'text.secondary' }}
    >
      If any information is missing or invalid, please update in your
      <Button
        variant="text"
        href="/identity/user/account?section=TEAM_INFORMATION"
        color="primary"
        size="small"
        sx={theme.typography.caption}
        onClick={onClick}
      >
        Account Settings
      </Button>
    </Typography>
  );
};
